// extracted by mini-css-extract-plugin
export var breadcrumb = "_1l-0";
export var breadcrumbArrow = "_1l-1";